import type { MasteryDashboardData, MasteryDashboardView } from '../types/mastery-map-dashboard/interfaces'
import type { MasteryMapDashboardStore } from './interfaces'
import type { ScopeMode } from '@shared/lib/scope'

import { useDisciplineStore } from '@entities/customer'
import { beginEntry, failEntry, settleEntry } from '@shared/lib/scope'

import { DEFAULT_DASHBOARD_VIEW } from '../../lib/view'

const getActiveId = (): number | null => useDisciplineStore().activeDiscipline?.id ?? null

export const actions = {
  begin (this: MasteryMapDashboardStore, id: number, mode: ScopeMode): number {
    return beginEntry(this.dashboardById, id, mode)
  },
  settle (this: MasteryMapDashboardStore, id: number, requestId: number, data: MasteryDashboardData): void {
    settleEntry(this.dashboardById, id, requestId, data)
  },
  fail (this: MasteryMapDashboardStore, id: number, requestId: number): void {
    failEntry(this.dashboardById, id, requestId)
  },
  markViewed (this: MasteryMapDashboardStore, disciplineId: number, assessmentId: number): void {
    const item = this.dashboardById[disciplineId]?.data?.list.find(entry => entry.assessment_id === assessmentId)
    if (item) item.is_viewed = true
  },
  updateView (this: MasteryMapDashboardStore, patch: Partial<MasteryDashboardView>): void {
    const id = getActiveId()
    if (id === null) return

    this.viewById[id] = { ...(this.viewById[id] ?? DEFAULT_DASHBOARD_VIEW), ...patch }
  },
}
